import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { FairPriceVerdict } from '../verdict/fair-price-verdict';

interface FairPriceResultCardProps {
    fairPrice: number;
    currentPrice: number;
    upsideDownside: number;
    currency: string;
    children?: React.ReactNode;
}

export const FairPriceResultCard: React.FC<FairPriceResultCardProps> = observer(
    ({ fairPrice, currentPrice, upsideDownside, currency, children }) => {
        const { t } = useTranslation();
        const isPositive = upsideDownside > 0;

        if (!(fairPrice > 0 && currentPrice > 0)) return null;

        return (
            <FairPriceVerdict
                currency={currency}
                values={[
                    {
                        label: t('layout.dialogs.fairPrice.result.fairPrice'),
                        value: fairPrice,
                    },
                    {
                        label: t('layout.dialogs.fairPrice.result.currentPrice'),
                        value: currentPrice,
                    },
                    {
                        label: t('layout.dialogs.fairPrice.result.upsideDownside'),
                        value: upsideDownside,
                        positive: isPositive,
                        negative: !isPositive,
                        format: 'percent',
                    },
                ]}
                pins={[
                    {
                        label: t('layout.dialogs.fairPrice.result.currentPrice'),
                        value: currentPrice,
                        variant: 'current',
                    },
                    {
                        label: t('layout.dialogs.fairPrice.result.fairPrice'),
                        value: fairPrice,
                        variant: 'fair',
                    },
                ]}
                upsideDownside={upsideDownside}
                showBadge={false}
            >
                {children}
            </FairPriceVerdict>
        );
    },
);
